import { asyncRoute } from '../../router';

export default asyncRoute(() => import(/* webpackChunkName: "Games" */ './components/Games'));
